import * as React from "react";
import * as pc from 'playcanvas';
import * as PlayCanvasHelper from './helpers/PlayCanvasHelper';
import GetBrowserInfo from './helpers/GetBrowserInfo';

declare const window: any;
window.pc = pc; //arreglo simple para que reconozca 'pc' en los scripts de playcanvas
const browserInfo: any = GetBrowserInfo();
const paramQuality = browserInfo.urlParams.get('quality');
const paramProfiler = browserInfo.urlParams.get('profiler');
const paramTestLOD = browserInfo.urlParams.get('testlod') === 'true';
const paramColorLOD = browserInfo.urlParams.get('colorlod') === 'true';
const introAnimation = browserInfo.urlParams.get('gsplat_effect') === 'true';

const EventFreeCameraAnimation = "event:FreeCameraAnimation";
const EventTownPlaningAnimation = "event:TownPlaningAnimation";

const defaultFOV = 45;
const amenityBillboardScale = 1;
const townPlanningBillboardScale = 1;
const showClickedMesh = false;
const showHoverMesh = false;
const showCameraSpherical = false;
const showCameraPosition = false;
const awsRootPath = "https://d1bsymnertnea6.cloudfront.net/"; //"https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/";
const isRunningLocally = ['localhost', '127.0.0.1', '192.168.1.7'].includes(window.location.hostname) === true;

type Props = {
  data: any;
  menuSelected: string;
  subMenuSelected: string;
  isSelectedTownplanning: any;
  isSelectedAmenities: string;
  isSelectedAttribute: any;
  isSelectedApto: any;
  selectAvailability: any;
  introView: any;
  isSelectedAmenitiesView: string;
  isSelectedAptoView: any;
  hotspotsSelected: any;

  showTextHotspots: boolean;
  isSideBarAsoleacion: boolean;

  setIsSelectedAmenitiesView: (value: string) => void;
  setIsSelectedAptoView: (value: any) => void;
  setIsSelectedApto: (value: any) => void;
  OnDetailsClicked: (hotspotID: string) => void;

  setIsLoading: (value: boolean) => void;
  setProgress: (value: number) => void;
}

const GaussianEngine: React.FC<Props> = ({ data, menuSelected, subMenuSelected, isSelectedTownplanning, isSelectedAmenities, isSelectedAttribute, isSelectedApto, selectAvailability, introView, isSelectedAmenitiesView, isSelectedAptoView, showTextHotspots, hotspotsSelected, isSideBarAsoleacion, setIsSelectedAmenitiesView, setIsSelectedAptoView, setIsSelectedApto, setIsLoading, setProgress, OnDetailsClicked}) => {

  const [sceneReady, setSceneReady] = React.useState(false);

  const [isPortrait, setIsPortrait] = React.useState(false);

  const showProfilerRef = React.useRef<boolean>(false);
  const profilerTimerRef = React.useRef<number>(0);

  const draggingRef = React.useRef<{x: number; y: number}|null>(null);
  const detailsHoverRef = React.useRef<boolean>(false);

  const timerRef = React.useRef<number>(0);
  const materialGaussian = React.useRef<pc.ShaderMaterial|null>(null);
  const startTimer = React.useRef<boolean>(false);

  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const appRef = React.useRef<pc.Application|null>(null);
  const cameraEntityRef = React.useRef<pc.Entity|null>(null);
  //const draggingRef = React.useRef<boolean>(false);
  const frameCountRef = React.useRef<number>(0);
  const isPortraitRef = React.useRef(false); //required for PC
  const selectedAptoRef = React.useRef<any>(null); //required for PC

  const isHoveringPropertyRef = React.useRef(false);
  const gsplatRef = React.useRef<pc.GSplatComponent|null|undefined>(null);
  const gsplatNodeRef = React.useRef<pc.Entity|null>(null);

  const rootEntityRef = React.useRef<pc.Entity|null>(null);
  const masterplanEntityRef = React.useRef<pc.Entity|null>(null);

  const propertiesRef = React.useRef<any>(null);
  const amenitiesRef = React.useRef<any>(null);
  //const camerasRef = React.useRef<any>(null);
  const cameraTargetRef = React.useRef<any>({});
  const cameraPositonRef = React.useRef<any>({});
  const cameraFovRef = React.useRef<any>({});
  const townPlanningRef = React.useRef<any>(null);
  const detailsRef = React.useRef<any>(null);
  const volumesRef = React.useRef<any>(null);

  const propertyByIdRef = React.useRef<any>({});
  const pulseAnimationRef = React.useRef<any>({});
  const colorAnimationRef = React.useRef<any>(null);

  const billboardAssetsRef = React.useRef<any>(null);
  const forceEngineResizeCountRef = React.useRef(0);
  const updateCoordsRef = React.useRef(false);

  const montserratMediumFontIDRef = React.useRef<number>(0);

  const activeAmenityView = React.useRef(""); //amenity ID view
  const activePropertyView = React.useRef(""); //property ID view
  //const activeTownPlanningView = React.useRef(""); //townplanning ID view
  const activeDetailView = React.useRef(""); //details ID view

  const Resize = React.useCallback( () => { //Este TIENE que estar antes de usarse
    setIsPortrait(window.innerWidth < window.innerHeight);

    //appRef.current?.resizeCanvas();
    PlayCanvasHelper.CustomResize();
  }, []);

  React.useEffect(() => {
    CreateScene();
    Resize();
    window.addEventListener('resize', Resize);
    canvasRef.current?.addEventListener('resize', Resize);
    canvasRef.current?.addEventListener('pointerdown', PointerDown);
    canvasRef.current?.addEventListener('pointerup', PointerUp);
    canvasRef.current?.addEventListener('pointermove', PointerMoved);
    canvasRef.current?.addEventListener('mouseenter', CanvasEnter);
    canvasRef.current?.addEventListener('mouseleave', CanvasExit);
    return () => {
      window.removeEventListener('resize', Resize);
      canvasRef.current?.removeEventListener('resize', Resize);
      canvasRef.current?.removeEventListener('pointerdown', PointerDown);
      canvasRef.current?.removeEventListener('pointerup', PointerUp);
      canvasRef.current?.removeEventListener('pointermove', PointerMoved);
      canvasRef.current?.removeEventListener('mouseenter', CanvasEnter);
      canvasRef.current?.removeEventListener('mouseleave', CanvasExit);
      PlayCanvasHelper.DestroyApp();
      //appRef.current?.destroy();
    };
  }, []);

  const PointerMoved = (event: PointerEvent) => {
    if (!canvasRef.current || !cameraEntityRef.current)
      return;

    if(draggingRef.current){
      const dx = event.clientX - draggingRef.current.x;
      const dy = event.clientY - draggingRef.current.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      if(distance > 10)
        setIsSelectedApto({});
    }

    if(detailsHoverRef.current)
      return;
    const pickedObject = PlayCanvasHelper.GetPickedMesh(event, cameraEntityRef.current.camera!);
    if(!pickedObject){
      if(isHoveringPropertyRef.current === true){
        document.body.style.cursor = 'grab';
        isHoveringPropertyRef.current = false;
      }
      return;
    }
    if(showHoverMesh){ console.log(pickedObject.name); }
    if(pickedObject.name.toLocaleLowerCase().includes("property")){
      isHoveringPropertyRef.current = true;
      document.body.style.cursor = 'pointer';
    }else if(isHoveringPropertyRef.current === true){
      isHoveringPropertyRef.current = false;
      document.body.style.cursor = 'grab';
    }
  }

  const PointerDown = (event: PointerEvent) => {
    if(!canvasRef.current || !cameraEntityRef.current || detailsHoverRef.current)
      return;
    draggingRef.current = {x: event.clientX, y: event.clientY};
    
    const pickedObject = PlayCanvasHelper.GetPickedMesh(event, cameraEntityRef.current.camera!);

    if(!pickedObject)
      return;
    if(showClickedMesh){ console.log(pickedObject.name); }
    if(pickedObject.name.toLocaleLowerCase().includes("property")){
      CheckProperty(pickedObject, event, true);
    }
  }
  const PointerUp = (event: PointerEvent) => {
    draggingRef.current = null;
  }

  const CheckProperty = (node: pc.GraphNode, event: PointerEvent, clicked: boolean = false) => {
    let propertyID: string = "";
    if(node.name.includes('@'))
      propertyID = PlayCanvasHelper.GetIDFromNodeName(node.name);
    if(!propertyID && node.parent && node.parent.name.includes('@'))
      propertyID = PlayCanvasHelper.GetIDFromNodeName(node.parent.name);
    if(!propertyID && node.parent?.parent && node.parent?.parent.name.includes('@'))
      propertyID = PlayCanvasHelper.GetIDFromNodeName(node.parent?.parent.name);
    if(!propertyID)
      return;
    
    const propertyData = propertyByIdRef.current[propertyID];
    if(!propertyData || !clicked)
      return;
    SelectProperty(propertyData, event.clientX, event.clientY)
  }

  const SelectProperty = (propertyData: any, screenX: number, screenY: number) => {
    if(!canvasRef.current)
      return;

    propertyData.verts=[];
    propertyData.verts[0]=[];
    propertyData.verts[0][0] = screenX;// * originalWidth / window.innerWidth;
    propertyData.verts[0][1] = screenY;// * originalHeight / window.innerHeight;
    setIsSelectedApto(propertyData);
  }

  React.useEffect(() => {
    isPortraitRef.current = isPortrait;
  }, [isPortrait]);

  React.useEffect(() => {
    selectedAptoRef.current = isSelectedApto;
  }, [isSelectedApto]);

  React.useEffect(() => {
    startTimer.current = introView === false;
    if(cameraEntityRef.current && cameraEntityRef.current.script){
      const orbitCamera = cameraEntityRef.current.script["orbitCamera"];
      orbitCamera.SetEnableAutoRotation(introView === false);
    }
  }, [introView]);

  React.useEffect(() => {
    MenuChanged();
    UpdateVolumeVisibility();
  }, [menuSelected]);

  React.useEffect(() => {
    UpdateTownPlanningVisibility();
    UpdateDetailedVisibility();
    UpdateVolumeVisibility();
  }, [subMenuSelected]);

  React.useEffect(() => {
    UpdateAmenitiesVisibility();
    if(activeAmenityView.current){
      AmenityViewAnimationOut(EventFreeCameraAnimation);
    }
  }, [isSelectedAmenities]);

  React.useEffect(() => {
    UpdateTownPlanningVisibility();
  }, [isSelectedTownplanning]);

  React.useEffect(() => {
    if(isSelectedAmenitiesView)
        AmenityViewAnimationIn();
    else
        AmenityViewAnimationOut(EventFreeCameraAnimation);
  }, [isSelectedAmenitiesView]);

  React.useEffect(() => {
    UpdateDetailedVisibility();
  }, [showTextHotspots]);

  React.useEffect(() => {
    UpdatePropertiesVisibility();
  }, [selectAvailability, isSelectedAttribute]);

  React.useEffect(() => {
    if(isSelectedAptoView){
      PropertyViewAnimationIn() 
    }else if(activePropertyView.current){
      PropertyViewAnimationOut(EventFreeCameraAnimation)
    }
    UpdateDetailedVisibility();
  }, [isSelectedAptoView]);

  React.useEffect(() => {
    const hotspotID = hotspotsSelected ? hotspotsSelected.hotspot_id : ""
    if(activeDetailView.current === hotspotID){
      DetailedViewAnimationOut();
    }else{
      activeDetailView.current = hotspotID;
      DetailedViewAnimationIn();
    }
  }, [hotspotsSelected]);

  const MenuChanged = () => {

    UpdatePropertiesVisibility();
    UpdateAmenitiesVisibility();
    UpdateTownPlanningVisibility();
    UpdateDetailedVisibility();

    if(menuSelected === 'Urbanismo'){
      if(activeAmenityView.current){
        AmenityViewAnimationOut(EventTownPlaningAnimation)
      }else if(activePropertyView.current){
        PropertyViewAnimationOut(EventTownPlaningAnimation)
      }else if(activeDetailView.current){
        DetailedViewAnimationOut(EventTownPlaningAnimation)
      }else{
        TownPlaningAnimation();
      }
    } else if (menuSelected !== ''){
      if(activeAmenityView.current){
        AmenityViewAnimationOut(EventFreeCameraAnimation)
      }else if(activePropertyView.current){
        PropertyViewAnimationOut(EventFreeCameraAnimation)
      }else if(activeDetailView.current){
        DetailedViewAnimationOut(EventFreeCameraAnimation)
      }else{
        FreeCameraAnimation();
      }
    }else if(activeAmenityView.current){
      AmenityViewAnimationOut(EventFreeCameraAnimation)
    }else if(activePropertyView.current){
      PropertyViewAnimationOut(EventFreeCameraAnimation)
    }else if(activeDetailView.current){
      DetailedViewAnimationOut(EventFreeCameraAnimation)
    }
  }

  const UpdateDetailedVisibility = () => {
    if(!detailsRef.current)
      return;    
    
    const showDetails = (menuSelected === "Inmuebles" || menuSelected === "") && subMenuSelected === "" && !isSelectedAptoView;
    for(const detailsID in detailsRef.current.billboards){
        detailsRef.current.billboards[detailsID].enabled = showDetails;
        detailsRef.current.texts[detailsID].enabled = showTextHotspots;
    }
  }

  const UpdateTownPlanningVisibility = () => {
    if(!townPlanningRef.current)
      return;
    //layouts
    for(const townPlaningKey in townPlanningRef.current.layouts){
      const enableChild = menuSelected === 'Urbanismo' && townPlaningKey === isSelectedTownplanning;
      const node = townPlanningRef.current.layouts[townPlaningKey];
      node.root.enabled = enableChild;
    }
    //billboards
  }

  const UpdateVolumeVisibility = () => {
    if(!volumesRef.current)
     return;

    for(const volumeMISC of volumesRef.current.miscs){
      const isGeneralSpin = menuSelected === "Urbanismo" || (subMenuSelected !== "" && hotspotsSelected)
      volumeMISC.enabled = !isGeneralSpin;
    }
    //SIEMPRE ESTÁN ACTIVOS EN 3D!!!
    
    // if(subMenuSelected !== "" && hotspotsSelected){
    //   //filtrar por volumen
    //   for(const volumeID in volumesRef.current.hierarchicals){
    //     volumesRef.current.hierarchicals[volumeID].enabled = false;
    //   }
    //   for(const hierarchical of hotspotsSelected.hierarchicals){
    //     const volumeID = hierarchical.hierarchicals_id;
    //     const node = volumesRef.current.hierarchicals[volumeID];
    //     if(node){node.enabled = true;}
    //   }
    // }else{
    //   //reactivar todos los volumes
    //   for(const volumeID in volumesRef.current.hierarchicals){
    //     volumesRef.current.hierarchicals[volumeID].enabled = true;
    //   }
    // }
  }

  const UpdateAmenitiesVisibility = (showActiveAmenity: boolean = false, createFocus: boolean = true) => {//en spin showActiveAmenity = true
    if(!amenitiesRef.current)
      return;

    if(menuSelected !== "Amenidades"){ //se apagan el root, billboards y highlights
      amenitiesRef.current.root.enabled = false;
      for(const amenityBillboardKey in amenitiesRef.current.billboards){
        amenitiesRef.current.billboards[amenityBillboardKey].enabled = false;
      }
      for(const amenityHighlightKey in amenitiesRef.current.highlights){
        amenitiesRef.current.highlights[amenityHighlightKey].enabled = false;
      }
    }else{
      amenitiesRef.current.root.enabled = true;

      const showAllAmenities = !(isSelectedAmenities);
      if(createFocus === true){
        for (const amenity of data.amenities.menu){
          if(amenity.id === isSelectedAmenities){
            AmmenityViewAnimationFocus(amenitiesRef.current.views[amenity.id].focusView);
            break;
          }
        }
      }
      for(const amenityBillboardKey in amenitiesRef.current.billboards){
        amenitiesRef.current.billboards[amenityBillboardKey].enabled = showAllAmenities === true || (showActiveAmenity && amenityBillboardKey === isSelectedAmenities);
      }
      for(const amenityHighlightKey in amenitiesRef.current.highlights){
        amenitiesRef.current.highlights[amenityHighlightKey].enabled = showAllAmenities === false && (amenityHighlightKey === isSelectedAmenities);
      }
    }
    
  }

  const AmmenityViewAnimationFocus = (focusView: pc.GraphNode) => {
    
    if(!cameraEntityRef.current || !cameraTargetRef.current || !cameraEntityRef.current.script)
      return;

    
    const orbitCamera = cameraEntityRef.current.script["orbitCamera"];
    const cameraAmenityAnimation = cameraEntityRef.current.script["cameraAmenityAnimation"];

    const direction = focusView.getPosition().clone().sub(cameraTargetRef.current.general.getPosition().clone());
    const angleRadians = Math.atan2(direction.x, direction.z);
    const nextAngle = PlayCanvasHelper.NormalizeAngle(PlayCanvasHelper.Radians2Degrees(angleRadians));

    const startingAngle = PlayCanvasHelper.NormalizeAngle(orbitCamera.yaw, nextAngle);
    const time = 3 * Math.abs(startingAngle-nextAngle) / 360;
    if(time < 0.04) // menos de 5° de diferencia
      return
    cameraAmenityAnimation.AnimationFocus(startingAngle, nextAngle, time);
  }

  const AmenityViewAnimationIn = () => { //revisar cambios a pasar
    if(!amenitiesRef.current  || !cameraEntityRef.current?.script)
      return;

    const cameraAmenityAnimation = cameraEntityRef.current.script["cameraAmenityAnimation"];
    const middlePositionNode = amenitiesRef.current.views[isSelectedAmenitiesView].middlePosition as pc.GraphNode;
    const finalPositionNode = amenitiesRef.current.views[isSelectedAmenitiesView].finalPosition as pc.GraphNode;
    const finalTargetNode = amenitiesRef.current.views[isSelectedAmenitiesView].finalTarget as pc.GraphNode;

    if(!middlePositionNode || !finalPositionNode || !finalTargetNode){
      console.error("not all cameraviews are defined for amenity: " + isSelectedAmenitiesView);
      return;
    }
    const middlePosition = middlePositionNode.getPosition().clone();
    const finalPosition = finalPositionNode.getPosition().clone();
    const finalTargetPosition = finalTargetNode.getPosition().clone();
          
    UpdateAmenitiesVisibility(false, false);

    activeAmenityView.current = isSelectedAmenitiesView;
    cameraAmenityAnimation.AnimationIn(middlePosition, finalPosition, finalTargetPosition);
    cameraEntityRef.current.camera!.fov = cameraFovRef.current.general;//reset fov
  }

  const AmenityViewAnimationOut = (nextEvent: string = "") => {//nextTransition: () => void
    if(!activeAmenityView.current || !amenitiesRef.current  || !cameraEntityRef.current?.script)
      return;

    UpdateAmenitiesVisibility(false, false);
    
    const cameraAmenityAnimation = cameraEntityRef.current.script["cameraAmenityAnimation"];
    const middlePositionNode = amenitiesRef.current.views[activeAmenityView.current].middlePosition as pc.GraphNode;
    const finalPositionNode = amenitiesRef.current.views[activeAmenityView.current].finalPosition as pc.GraphNode;
    const finalTargetNode = amenitiesRef.current.views[activeAmenityView.current].finalTarget as pc.GraphNode;
    
    if(!middlePositionNode || !finalPositionNode || !finalTargetNode){
      return;
    }

    const middlePosition = middlePositionNode.getPosition().clone();
    const finalPosition = cameraPositonRef.current.general.getPosition().clone();
    const finalTargetPosition = cameraTargetRef.current.general.getPosition().clone();

    activeAmenityView.current = "";

    cameraAmenityAnimation.AnimationOut(middlePosition, finalPosition, finalTargetPosition, nextEvent);
    cameraEntityRef.current.camera!.fov = cameraFovRef.current.general;//reset fov
  }

  const FreeCameraAnimation = () => {
    cameraEntityRef.current!.camera!.fov = cameraFovRef.current.general;//reset fov
    //console.log("free camera")
  }

  const PropertyViewAnimationIn = () => { //revisar cambios a pasar
    if(!propertiesRef.current || !cameraEntityRef.current?.script)
      return;

    const cameraPropertyAnimation = cameraEntityRef.current.script["cameraPropertyAnimation"];
    const middlePositionNode = propertiesRef.current.views[isSelectedAptoView.id].middlePosition as pc.GraphNode;
    const finalPositionNode = propertiesRef.current.views[isSelectedAptoView.id].finalPosition as pc.GraphNode;
    const finalTargetNode = propertiesRef.current.views[isSelectedAptoView.id].finalTarget as pc.GraphNode;

    if(!middlePositionNode || !finalPositionNode || !finalTargetNode){
      console.error("not all cameraviews are defined for property: " + isSelectedAptoView.id);
      return;
    }
    const middlePosition = middlePositionNode.getPosition().clone();
    const finalPosition = finalPositionNode.getPosition().clone();
    const finalTargetPosition = finalTargetNode.getPosition().clone();

    UpdatePropertiesVisibility(false);

    activePropertyView.current = isSelectedAptoView.id;
    cameraPropertyAnimation.AnimationIn(middlePosition, finalPosition, finalTargetPosition);
    cameraEntityRef.current.camera!.fov = cameraFovRef.current.general;//reset fov
  }

  const PropertyViewAnimationOut = (nextEvent: string = "") => {//nextTransition: () => void
    if(!propertiesRef.current || !cameraEntityRef.current?.script)
      return;

    UpdatePropertiesVisibility();

    if(activeDetailView.current){
      activePropertyView.current = "";
      DetailedViewAnimationIn();
      return;
    }
    
    const cameraPropertyAnimation = cameraEntityRef.current.script["cameraPropertyAnimation"];
    const middlePositionNode = propertiesRef.current.views[activePropertyView.current].middlePosition as pc.GraphNode;
    const finalPositionNode = propertiesRef.current.views[activePropertyView.current].finalPosition as pc.GraphNode;
    const finalTargetNode = propertiesRef.current.views[activePropertyView.current].finalTarget as pc.GraphNode;
    
    if(!middlePositionNode || !finalPositionNode || !finalTargetNode){
      return;
    }

    const middlePosition = middlePositionNode.getPosition().clone();
    const finalPosition = cameraPositonRef.current.general.getPosition().clone();
    const finalTargetPosition = cameraTargetRef.current.general.getPosition().clone();

    activePropertyView.current = "";

    cameraPropertyAnimation.AnimationOut(middlePosition, finalPosition, finalTargetPosition, nextEvent);
    cameraEntityRef.current.camera!.fov = cameraFovRef.current.general;//reset fov
  }

  const DetailedViewAnimationIn = () => { //revisar cambios a pasar
    if(!cameraPositonRef.current || !cameraTargetRef.current || !cameraEntityRef.current?.script)
      return;

    UpdateDetailedVisibility();

    const cameraTownplanningAnimation = cameraEntityRef.current.script["cameraTownplanningAnimation"];
    const finalPositionNode = cameraPositonRef.current[activeDetailView.current] as pc.GraphNode;
    const finalTargetNode = cameraTargetRef.current[activeDetailView.current] as pc.GraphNode;

    if(!finalPositionNode || !finalTargetNode){
      console.error("not all cameraviews are defined for detailed: " + isSelectedAptoView.id);
      return;
    }
    const finalPosition = finalPositionNode.getPosition().clone();
    const finalTargetPosition = finalTargetNode.getPosition().clone();

    cameraTownplanningAnimation.AnimationIn(finalPosition, finalTargetPosition);
    cameraEntityRef.current.camera!.fov = cameraFovRef.current[activeDetailView.current];//reset fov
  }

  const DetailedViewAnimationOut = (nextEvent: string = "") => {//nextTransition: () => void
    if(!cameraPositonRef.current || !cameraTargetRef.current || !cameraEntityRef.current?.script)
      return;

    UpdateDetailedVisibility();
    
    const cameraTownplanningAnimation = cameraEntityRef.current.script["cameraTownplanningAnimation"];
    const finalPositionNode = cameraPositonRef.current[activeDetailView.current] as pc.GraphNode;
    const finalTargetNode = cameraTargetRef.current[activeDetailView.current] as pc.GraphNode;
    
    if(!finalPositionNode || !finalTargetNode){
      return;
    }

    const finalPosition = cameraPositonRef.current.general.getPosition().clone();
    const finalTargetPosition = cameraTargetRef.current.general.getPosition().clone();

    activeDetailView.current = "";
    cameraTownplanningAnimation.AnimationOut(finalPosition, finalTargetPosition, nextEvent);
    cameraEntityRef.current.camera!.fov = cameraFovRef.current.general;//reset fov
  }

  const TownPlaningAnimation = () => {
    cameraEntityRef.current!.camera!.fov = cameraFovRef.current.townplanning;//townplanning fov
    //console.log("TownPlaningAnimation");
  }

  React.useEffect(() => {
    if(Object.keys(isSelectedApto).length > 0 || !propertiesRef.current)
      return;
    colorAnimationRef.current = null;
    ResetPropertiesColor();
  }, [isSelectedApto]);

  const ResetPropertiesColor = () => {
    for (const propertyID in propertiesRef.current.colorAnimation){
      const colorConfig = propertiesRef.current.colorAnimation[propertyID];
      for (const material of colorConfig.materials){
        material.emissive = colorConfig.color.clone();
        material.specular = colorConfig.color.clone();
        material.update();
      }
    }
  }

  const CanvasEnter = () => {
    PlayCanvasHelper.FullCanvasAttach();
    document.body.style.cursor = 'grab';
  }

  const CanvasExit = () => {
    PlayCanvasHelper.FullCanvasDetach();
    document.body.style.cursor = 'default';
  }

  const UpdatePropertiesVisibility = (showActiveProperty: boolean = true) => {
    if(!data || !propertiesRef.current)
      return;    
    if(!propertiesRef.current.billboards || !propertiesRef.current.highlights)
      return;

    const showProperties = (menuSelected === "Inmuebles") && showActiveProperty;
    propertiesRef.current.root.enabled = showProperties;

    for(const property of data.properties.property){
      propertyByIdRef.current[property.id] = property;
      const isFiltered = showProperties && PlayCanvasHelper.FilterProperty(property, isSelectedAttribute, selectAvailability);
      
      const highlightProperty = propertiesRef.current.highlights[property.id]
      if(highlightProperty){ highlightProperty.enabled = isFiltered }

      const billboardProperty = propertiesRef.current.billboards[property.id]
      if(billboardProperty){ billboardProperty.enabled = isFiltered }
    }
  }

  const AnimationEnded = () : void =>  {
    console.log("react animation dened");
  }


  const CreateScene = async () => {
    if(!canvasRef.current)
      return;

    PlayCanvasHelper.SetCanvas(canvasRef.current);
    const modelsURLs = {
      project: awsRootPath + data.models.project_glb, //awsRootPath + data.models.project_glb || `./models/project_v5.glb`
      dome_desktop: awsRootPath + data.models.dome_desktop, //awsRootPath + data.models.dome_desktop || `./models/dome_desktop_v4.glb`
      dome_mobile: awsRootPath + data.models.dome_mobile, //awsRootPath + data.models.dome_mobile || `./models/dome_mobile_v4.glb`
      sogs_high: data.models.sogs_high ? (awsRootPath + data.models.sogs_high + "/meta.json") : "", //awsRootPath + data.models.sogs_high || "./models/sogs_high_v4/meta.json"
      sogs_low: data.models.sogs_low ? (awsRootPath + data.models.sogs_low + "/meta.json") : "", //awsRootPath + data.models.sogs_low || "./models/sogs_low_v4/meta.json"
      sogs_lod: data.models.sogs_lod ? (awsRootPath + data.models.sogs_lod + "/lod-meta.json") : "", //awsRootPath + data.models.sogs_high + "/meta.json", //awsRootPath + data.models.sogs_high || "./models/sogs_high_v4/meta.json"
    }; 
    const creationResults = await PlayCanvasHelper.CreateScene3D(modelsURLs, setProgress, browserInfo, paramQuality, paramProfiler, introAnimation, showCameraSpherical);

    const app = creationResults.app;
    appRef.current = creationResults.app;
    gsplatRef.current = creationResults.gsplat;
    materialGaussian.current= creationResults.gsplatMaterial
    gsplatNodeRef.current = creationResults.gsplatNode;
    showProfilerRef.current = creationResults.showProfiler;
    cameraEntityRef.current = creationResults.cameraEntity;
    billboardAssetsRef.current = creationResults.billboardAssets;
    rootEntityRef.current = creationResults.rootEntity;
    montserratMediumFontIDRef.current = creationResults.montserratMediumFontID;

    app.on('DetailsClicked', DetailsClicked);
    app.on('PropertyClicked', PropertyClicked);
    app.on('DetailsHover', DetailsHover);
    app.on(EventFreeCameraAnimation, FreeCameraAnimation);
    app.on(EventTownPlaningAnimation, TownPlaningAnimation);

    cameraEntityRef.current.camera!.fov = defaultFOV;
    //cameraEntityRef.current.camera!.horizontalFov = true;

    app.on('update', (dt) => { SceneFrame(dt) });

    await WaitForNextFrames(2); //para asegurar que se recalculen las matrices de los notos ANTES de hacer cálculos.

    //busca al nodo masterplan, desactiva el picking en los demás (si existen)
    if(rootEntityRef.current.name.toLocaleLowerCase().includes("masterplan")){
      masterplanEntityRef.current = rootEntityRef.current;
    }else{
      for(const masterplanNode of rootEntityRef.current.children){
        if(masterplanNode.name.toLocaleLowerCase().includes("masterplan")){
          masterplanEntityRef.current = masterplanNode as pc.Entity;
        }else{
          masterplanNode.enabled = false;
          //PlayCanvasHelper.EnablePickRecursive(masterplanNode, false);
        }
      }
    }
    if(masterplanEntityRef.current){
      for(const pluginLayer of masterplanEntityRef.current.children){
        const pluginLayerName = pluginLayer.name.toLocaleLowerCase();
        if (pluginLayerName.includes("amenities")) {
          SetupAmenities(pluginLayer);
          //pluginLayer.enabled = false;
        } else if (pluginLayerName.includes("cameras")) {
          SetupCameras(pluginLayer);
        } else if (pluginLayerName.includes("details")) {
          SetupDetails(pluginLayer);
        } else if (pluginLayerName.includes("properties")) {
          SetupProperties(pluginLayer);
        } else if (pluginLayerName.includes("townplanning")) {
          SetupTownPlanning(pluginLayer);
        } else if (pluginLayerName.includes("volume")) {
          SetupVolumes(pluginLayer);
        }
      }
    }
    //finalizada la carga y configuracion de los archivos
    setProgress(100); //100% DE CARGA
    setIsLoading(false);
    setSceneReady(true);
  }

  const DetailsClicked = (id: string): void => {
    OnDetailsClicked(id);
  }

  const PropertyClicked = (event: any, propertyID: string): void => {
    const propertyData = propertyByIdRef.current[propertyID];
    if(!propertyData)
      return;
    SelectProperty(propertyData, event.x, event.y)
  }

  const DetailsHover = (isHovering: boolean): void => {
    detailsHoverRef.current = isHovering;
  }

  const SetupAmenities = (parentNode: pc.Entity|pc.GraphNode): void => {
    amenitiesRef.current = {};
    amenitiesRef.current.views = {};
    amenitiesRef.current.highlights = {};
    amenitiesRef.current.billboards = {};
    amenitiesRef.current.root = parentNode;
    amenitiesRef.current.root.enabled = false;//false

    const color = new pc.Color().fromString(data.colors.main_buttons.trim());//////// PONER DESDE ADMINISTRACIONNNNNNNN !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const materialBorder = PlayCanvasHelper.CreateLayoutMaterialFromColor("borderMat@allamenities", color, true, 1.0);
    const materialLayout = PlayCanvasHelper.CreateLayoutMaterialFromColor("layoutMat@allamenities", color, true, 0.3);

    const amenitiesWithview: string[] = [];
    for(const amenityNode of parentNode.children){
      amenityNode.enabled = true;//false
      const amenityID = PlayCanvasHelper.GetIDFromNodeName(amenityNode.name);
      amenitiesRef.current.highlights[amenityID] = amenityNode;///???
      for (const layoutOrBillboardOrCameraNode of amenityNode.children) {
        const layoutOrBillboardOrCameraName = layoutOrBillboardOrCameraNode.name.toLocaleLowerCase();

        if(layoutOrBillboardOrCameraName.includes("billboard")){
          AddAmenityBillboard(layoutOrBillboardOrCameraNode, amenityID);
        }else if(layoutOrBillboardOrCameraName.includes("layout")){
          AddAmenityLayouts(layoutOrBillboardOrCameraNode as pc.Entity, amenityID, materialBorder, materialLayout, color)
        }else if(layoutOrBillboardOrCameraName.includes("camera")){
          //TODO mirar cómo reducir esto con un script....
          amenitiesRef.current.views[amenityID] = {};
          let cameras = 4;
          for (const cameraParam of layoutOrBillboardOrCameraNode.children) {
            const paramName = cameraParam.name.toLocaleLowerCase();
            if(paramName.includes("middleposition")){
              amenitiesRef.current.views[amenityID].middlePosition = cameraParam;
              cameras = cameras - 1;
            }else if(paramName.includes("finalposition")){
              amenitiesRef.current.views[amenityID].finalPosition = cameraParam;
              cameras = cameras - 1;
            }else if(paramName.includes("finaltarget")){
              amenitiesRef.current.views[amenityID].finalTarget = cameraParam;
              cameras = cameras - 1;
            }
            else if(paramName.includes("focusview")){
              amenitiesRef.current.views[amenityID].focusView = cameraParam;
              cameras = cameras - 1;
            }
          }
          if(cameras === 0){
            amenitiesWithview.push(amenityID); //descomentar para activar la vista
          }
        }
      }
    }

    //enable views for defined
    for(const amenity of data.amenities.menu){
      for(const amenityID of amenitiesWithview){
        if(amenity.id === amenityID){
          amenity.view3d = true;
          break;
        }
      }
      /*for(const amenityMainframe of amenitiesMainFrames){
        if(amenity.id === amenityMainframe.id){
          amenity.mainFrame = amenityMainframe.mainFrame;
          break;
        }
      }*/
    }

  }

  const SetupCameras = (parentNode: pc.Entity|pc.GraphNode): void => {
    for(const cameraNode of parentNode.children){
      let cameraName = cameraNode.name.toLocaleLowerCase();
      if(cameraName.includes("intro")) cameraName = "intro";
      if(cameraName.includes("start")) cameraName = "general";
      if(cameraName.includes("townplanning")) cameraName = "townplanning";

      cameraFovRef.current[cameraName] = defaultFOV;
      for(const cameraChildNode of cameraNode.children){
        const cameraChildNodeName = cameraChildNode.name.toLocaleLowerCase();
        if(cameraChildNodeName.includes("position")){
          cameraPositonRef.current[cameraName] = cameraChildNode;
          for(const firstCameraChildNode of cameraChildNode.children){
            cameraPositonRef.current[cameraName] = firstCameraChildNode;
          }
        }else if(cameraChildNodeName.includes("target")){
          cameraTargetRef.current[cameraName] = cameraChildNode;
          for(const firstCameraChildNode of cameraChildNode.children){
            cameraTargetRef.current[cameraName] = firstCameraChildNode;
          }
        }else if(cameraChildNodeName.includes("fov")){
          let fov = cameraChildNode.getLocalScale().x;
          for(const firstCameraChildNode of cameraChildNode.children){
            fov = firstCameraChildNode.getLocalScale().x;
          }
          cameraFovRef.current[cameraName] = fov;
        }
      }
    }
    //cameraEntityRef.current!.script!["orbitCamera"].resetAndLookAtPoint(cameraPositonRef.current.general.getPosition().clone(), cameraTargetRef.current.general.getPosition().clone());
    cameraEntityRef.current!.script!["orbitCamera"].ResetStartingState(cameraPositonRef.current.general.getPosition().clone(), cameraTargetRef.current.general.getPosition().clone());
    cameraEntityRef.current!.camera!.fov = cameraFovRef.current.general;
  }

  const SetupDetails = (parentNode: pc.Entity|pc.GraphNode): void => {
    
    detailsRef.current = {};
    detailsRef.current.texts = {};
    detailsRef.current.billboards = {};
    detailsRef.current.root = parentNode;
    detailsRef.current.root.enabled = true;

    const color = new pc.Color().fromString(data.colors.main_buttons.trim());

    for(const hotspotNode of parentNode.children){
      const detailsID = PlayCanvasHelper.GetIDFromNodeName(hotspotNode.name);
      const currentHotspots: any = data?.hierarchical_groups?.find((e: any) => e.hotspot_id === detailsID);
      const isClickeable: boolean = currentHotspots.detailed_view === 1;
      const detailsName = currentHotspots ? currentHotspots.hotspot_name : "Error";
      cameraFovRef.current[detailsID] = defaultFOV;
      
      for(const billboardCamNode of hotspotNode.children){
        const billboardCamNodeName = billboardCamNode.name.toLocaleLowerCase();
        if(billboardCamNodeName.includes("billboard")){
          const billboard = new pc.Entity("billboardProp@"+detailsID);
          billboard.addComponent('script');
          const textMesh = PlayCanvasHelper.CreateCapsuleBillboardTextNode(billboardAssetsRef.current, billboard, detailsID, montserratMediumFontIDRef.current, detailsName, new pc.Color(1,1,1), color, 100, true, isClickeable);
          billboard.script?.["billboardCapsuleScalerAndLookAt"].ChangeLookAtEntity(cameraEntityRef.current);
          billboard.script?.["billboardCapsuleScalerAndLookAt"].SetPortraitRef(isPortraitRef);
          billboard.addChild(textMesh);
          billboardCamNode.addChild(billboard);
          detailsRef.current.billboards[detailsID] = billboard;
          detailsRef.current.texts[detailsID] = textMesh.children[1];
        }else if(billboardCamNodeName.includes("position")){
          cameraPositonRef.current[detailsID] = billboardCamNode;
          for(const cameraChildNode of billboardCamNode.children){
            cameraPositonRef.current[detailsID] = cameraChildNode;
          }
        }else if(billboardCamNodeName.includes("target")){
          cameraTargetRef.current[detailsID] = billboardCamNode;
          for(const cameraChildNode of billboardCamNode.children){
            cameraTargetRef.current[detailsID] = cameraChildNode;
          }
        }else if(billboardCamNodeName.includes("fov")){
          let fov = billboardCamNode.getLocalScale().x;
          for(const cameraChildNode of billboardCamNode.children){
            fov = cameraChildNode.getLocalScale().x;
          }
          cameraFovRef.current[detailsID] = fov;
        }
      }
    }
  }

  const SetupProperties = (parentNode: pc.Entity|pc.GraphNode): void => {
    
    propertiesRef.current = {};
    propertiesRef.current.views = {};
    propertiesRef.current.highlights = {};
    propertiesRef.current.billboards = {};
    propertiesRef.current.colorAnimation = {};
    propertiesRef.current.root = parentNode;
    propertiesRef.current.root.enabled = false;

    const color = PlayCanvasHelper.GetRGBFromHexString(data.colors.secondary_text);
    const textColorString = `rgb(${color.r}, ${color.g}, ${color.b})`;
    const textFillString = `rgba(${color.r}, ${color.g}, ${color.b}, 0.01)`;
    const colorMaterials: any = {};

    const hierarchicalLevel = PlayCanvasHelper.GetIDFromNodeName(propertiesRef.current.root.name).toLocaleLowerCase();
    //Nota: se podría hacer recursivamente el recorrido de las jerarquías.
    //Sin embargo prefiero así para que sea fácil de entender lo que se está haciendo.
    if(hierarchicalLevel.includes('h1')){
      for(const level1 of parentNode.children){
        const level1ID = PlayCanvasHelper.GetIDFromNodeName(level1.name);
        for(const floor of level1.children){
          const floorID = PlayCanvasHelper.GetIDFromNodeName(floor.name);
          if(floorID === level1ID){ //SÍ es un nodo de piso
            for(const aptoNode of floor.children){
              const aptoID = PlayCanvasHelper.GetIDFromNodeName(aptoNode.name);
              propertiesRef.current.highlights[aptoID] = aptoNode;
            }
          }else{//no es un piso, es un apto
            propertiesRef.current.highlights[floorID] = floor;
          }
        }
      }
    }
    if(hierarchicalLevel.includes('h2')){
      for(const level2 of parentNode.children){
        for(const level1 of level2.children){
          const level1ID = PlayCanvasHelper.GetIDFromNodeName(level1.name);
          for(const floor of level1.children){
            const floorID = PlayCanvasHelper.GetIDFromNodeName(floor.name);
            if(floorID === level1ID){ //SÍ es un nodo de piso
              for(const aptoNode of floor.children){
                const aptoID = PlayCanvasHelper.GetIDFromNodeName(aptoNode.name);
                propertiesRef.current.highlights[aptoID] = aptoNode;
              }
            }else{//no es un piso, es un apto
              propertiesRef.current.highlights[floorID] = floor;
            }
          }
        }
      }
    }

    let towers: any = "";
    for (const attribute of data.properties.attributes){//es solo para extraer el color
      if(attribute.type === "Hierarchical" && attribute.hierarchicalLevel === 'Jerarquico #1'){
        towers = attribute.values;
        break;
      }
    }

    for (const propertyData of data.properties.property) {
      const propertyID = propertyData.id;
      const propertyName = propertyData.property;
      const propertyNode = propertiesRef.current.highlights[propertyData.id]
      
      if (propertyNode){
        let colorHex: any = '#000000';
        if(data.properties.disponibilidad === true){//prioridad Disponibilidad
          colorHex = PlayCanvasHelper.GetAptoColorByAvailability(propertyData.availability)
        }else{
          let attributesType: any = null;
          for (const attribute of data.properties.attributes){//segundo Tipología
            if(attribute.type === "Tipologia" || attribute.name === "Apto tipo" || attribute.name === "Casas tipo"){
              attributesType = attribute.values;
              break;
            }
          }
          if(!attributesType){ //último el jerárquico 1
            let hierarchical_id = "";
            for (const attribute of propertyData.values){
              if(attribute.type === 'Hierarchical' && attribute.hierarchicalLevel === 'Jerarquico #1'){
                hierarchical_id = attribute.IdValue;
              }
            }
            if(hierarchical_id && towers){
              for(const tower of towers){
                if(tower.id === hierarchical_id){
                  colorHex = tower.layoutFill;
                }
              }
            }
          }else{
            colorHex = PlayCanvasHelper.GetAptoColorByType(propertyData, attributesType)
          }
        }
        if(!colorMaterials[colorHex]){
          const bgColor = new pc.Color();
          colorMaterials[colorHex] = {
            bgColor: bgColor.fromString(colorHex),
            materialBorder: PlayCanvasHelper.CreateLayoutMaterialFromColor("borderMat@"+propertyID, bgColor, true, 1.0),
            materialLayout:PlayCanvasHelper.CreateLayoutMaterialFromColor("layoutMat@"+propertyID, bgColor, true, 0.7),
          }
        }
        const bgColor = colorMaterials[colorHex].bgColor;
        const materialBorder = colorMaterials[colorHex].materialBorder;
        const materialLayout = colorMaterials[colorHex].materialLayout;

        for (const layoutOrBillboard of propertyNode.children) {//hijos del inmueble
          const layoutOrBillboardName = layoutOrBillboard.name.toLocaleLowerCase();
          if(layoutOrBillboardName.includes("billboard")){
            AddPropertyBillboard(layoutOrBillboard, propertyName, propertyID, bgColor, textColorString, textFillString);
          }else if(layoutOrBillboardName.includes("layoutshape")){
            AddPropertyLayouts(layoutOrBillboard, propertyID, bgColor, materialBorder, materialLayout);
          }else if(layoutOrBillboardName.includes("camera")){//puede ser orbital o fpv
            propertiesRef.current.views[propertyData.id] = {};
            let cameras = 3;
            for (const cameraParam of layoutOrBillboard.children) {
              const paramName = cameraParam.name.toLocaleLowerCase();
              if(paramName.includes("middleposition")){
                propertiesRef.current.views[propertyData.id].middlePosition = cameraParam;
                cameras = cameras - 1;
              }else if(paramName.includes("finalposition")){
                propertiesRef.current.views[propertyData.id].finalPosition = cameraParam;
                cameras = cameras - 1;
              }else if(paramName.includes("finaltarget")){
                propertiesRef.current.views[propertyData.id].finalTarget = cameraParam;
                cameras = cameras - 1;
              }
            }
            if(cameras !== 0){
              console.error("Contedo de cameraview incorrecto en propiedad "+propertyData.id);
            }
          }
        }
      }
    }
  }

  const SetupTownPlanning = (parentNode: pc.Entity|pc.GraphNode): void => {
    townPlanningRef.current = {};
    townPlanningRef.current.views = {};
    townPlanningRef.current.layouts = {};
    townPlanningRef.current.root = parentNode;
    townPlanningRef.current.enabled = true;//false

    const mainColor = new pc.Color().fromString(data.colors.main_buttons.trim());

    for(const hierarchicalNode of parentNode.children){
      hierarchicalNode.enabled = false;//false
      const hierarchicalNodeName = hierarchicalNode.name.toLocaleLowerCase();//Hierarchical1/torres) | Hierarchical2/etapas)
      
      for(const elementsMesh of hierarchicalNode.children){//torre 1, torre 2, torre 3 | etapa 1, etapa 2, etapa 3

        elementsMesh.enabled = true;
        const elementID = PlayCanvasHelper.GetIDFromNodeName(elementsMesh.name);
        let elementName = "";
        let hierarchicalName = "";
        const color = new pc.Color().fromString(data.colors.main_buttons.trim());

        for (const attribute of data.properties.attributes){
          if( (hierarchicalNodeName === "hierarchical1" && attribute.hierarchicalLevel === 'Jerarquico #1') || (hierarchicalNodeName === "hierarchical2" && attribute.hierarchicalLevel === 'Jerarquico #2')){
            hierarchicalName = attribute.name;
            for (const element of attribute.values){
              if(element.id === elementID){
                color.fromString(element.layoutFill);
                elementName = element.value;
                break;
              }
            }
            break;
          }
        }

        if(!townPlanningRef.current.layouts[hierarchicalName]){
          townPlanningRef.current.layouts[hierarchicalName] = {
            root: hierarchicalNode, //Hierarchical1 (torres) | Hierarchical2 (etapas)
            nodes: [],
          }
        }
        townPlanningRef.current.layouts[hierarchicalName].nodes.push(elementsMesh);

        for (const layoutNode of elementsMesh.children) {
          const layoutNodeName = layoutNode.name.toLocaleLowerCase();
          if(layoutNodeName.includes("layout")){
            AddTownPlanningLayouts(layoutNode, elementID, color);
          }else if(layoutNodeName.includes("billboard")){
            AddTownPlanningBillboard(layoutNode, elementID, elementName, mainColor);//color
          }
        }

      }
    }
  }

  const SetupVolumes = (parentNode: pc.GraphNode): void => {
    volumesRef.current = {};
    volumesRef.current.hierarchicals = {};
    volumesRef.current.miscs = [];
    volumesRef.current.root = parentNode;
    volumesRef.current.root.enabled = true;//true
    PlayCanvasHelper.EnablePickRecursive(parentNode, true);

    const fakeOcclusionMat = new pc.StandardMaterial();
    fakeOcclusionMat.depthWrite = true;  // Escribe en Z-buffer
    fakeOcclusionMat.depthTest = true;
    fakeOcclusionMat.blendType = pc.BLEND_NONE;
    fakeOcclusionMat.redWrite = false;
    fakeOcclusionMat.greenWrite = false;
    fakeOcclusionMat.blueWrite = false;
    fakeOcclusionMat.alphaWrite = false;
    fakeOcclusionMat.update();

    for(const volumeNode of parentNode.children){
      const hierarchicalID = PlayCanvasHelper.GetIDFromNodeName(volumeNode.name);
      for(const layoutNode of volumeNode.children){
        const layoutNodeName = layoutNode.name.toLocaleLowerCase();
        if(layoutNodeName.includes("freeshape")){
          if(!volumeNode.name.toLocaleLowerCase().includes("misc"))
            volumesRef.current.hierarchicals[hierarchicalID] = layoutNode;
          else
            volumesRef.current.miscs.push(layoutNode)
          for(const meshNode of layoutNode.children){
            PlayCanvasHelper.SetNodeMaterial(meshNode, fakeOcclusionMat);
          }
        }
      }
    }
  }

  const AddAmenityBillboard = async (node: pc.GraphNode, amenityID: string) => {    
    if(!appRef.current || !billboardAssetsRef.current)
      return;

    const amenityBillboardScale = 10;
    let startPointNode: pc.GraphNode|null = null;
    let endPointNode: pc.GraphNode|null = null;
    for(const point of node.children){
      const pointName = point.name.toLocaleLowerCase();
      if(pointName.includes('startpoint'))
        startPointNode = point;
      if(pointName.includes('endpoint')){
        endPointNode = point;
      }
        
    }

    let iconURL: string|null = null
    for(const amenityData of data.amenities.menu){
      if(amenityData.id === amenityID){
        iconURL = amenityData.icon;
      }
    }

    if(!startPointNode || !endPointNode || !iconURL)
      return;

    const scale = new pc.Vec3(amenityBillboardScale, amenityBillboardScale, amenityBillboardScale);

    const billboardParent = new pc.Entity("billboardParent@"+amenityID);
    billboardParent.setLocalPosition( startPointNode.getPosition().clone() );
    appRef.current.root.addChild(billboardParent);

    const billboardEnd = new pc.Entity("billboardEnd@"+amenityID);
    billboardParent.addChild(billboardEnd);
    billboardEnd.setPosition( endPointNode.getPosition().clone() );

    billboardParent.addComponent('script');
    billboardParent.script?.create('amenityBehavior', {
      attributes: {
        billboardEndEntity: billboardEnd,
        cameraEntity: cameraEntityRef.current,
        freeRotation: false
      }
    });
    billboardParent.script?.["amenityBehavior"].SetPortraitRef(isPortraitRef);

    //creacion billboard
    const billboard = billboardAssetsRef.current.ammenityMesh.clone("billboard@"+amenityID) as pc.Entity
    billboard.enabled = true;
    billboardEnd.addChild(billboard);
    billboard.setLocalPosition(new pc.Vec3(0, 0.5*amenityBillboardScale, 0));
    billboard.setLocalEulerAngles( new pc.Vec3(0,180,0) );
    billboard.setLocalScale( scale );

    //creacion esfera inicial
    const tubeMaterial = PlayCanvasHelper.CreateLayoutMaterialFromColor("tubeMaterial@"+amenityID, new pc.Color(1, 1, 1), false, 1);
    const startSphereBillboard = new pc.Entity("sphere@"+amenityID);
    startSphereBillboard.addComponent("model", { type: "sphere" });
    startSphereBillboard.model!.material = tubeMaterial;
    startSphereBillboard.setLocalScale( new pc.Vec3(0.2 * scale.x, 0.2 * scale.y, 0.2 * scale.z) );
    billboardParent.addChild(startSphereBillboard);

    //creacion tubo intermedio
    const tube = new pc.Entity();
    tube.addComponent("model", {type: "cylinder",});
    tube.model!.material = tubeMaterial;
    billboardParent.addChild(tube);
    const direction = billboardEnd.getLocalPosition().clone().mulScalar(1);
    const length = direction.length();

    const midpoint = direction.clone().mulScalar(0.5);
    tube.setLocalPosition(midpoint);
    tube.setLocalScale(0.05 * scale.x, length, 0.05 * scale.z);

    const up = new pc.Vec3(0, 1, 0);
    const quat = new pc.Quat();
    quat.setFromDirections(up, direction.clone().normalize());
    tube.setRotation(quat);

    const materialIcon = PlayCanvasHelper.CreateLayoutMaterialFromColor("billboardMaterial", new pc.Color(0,0,0), true, 1.0);
    materialIcon.opacityMapChannel = "a";

    const billboardIconMesh = new pc.Entity("icon"+amenityID);
    billboard.addChild( billboardIconMesh );
    billboardIconMesh.addComponent("model", { type: "plane" });
    billboardIconMesh.model!.material = materialIcon;
    billboardIconMesh.setLocalEulerAngles(new pc.Vec3(90, 0, 0));
    billboardIconMesh.setLocalPosition(new pc.Vec3(0, 0, 0.05));

    billboardParent.enabled = false;
    PlayCanvasHelper.EnablePickRecursive(billboardParent, false);
    amenitiesRef.current.billboards[amenityID] = billboardParent;

    //carga del ícono. Lo hago al final para no afectar la funcionalidad por si hay un error de lectura
    //const iconPath = isRunningLocally === true ? "./models/icons/test_icon.png" : awsRootPath + iconURL.replace(".svg",".png");
    const iconPath = awsRootPath + iconURL.replace(".svg",".png");
    const textureIcon = await PlayCanvasHelper.LoadTexture("icon", iconPath);
    PlayCanvasHelper.SoftTextures(textureIcon);
    let planeWidht = 0.5;//scale.x;
    let planeHeight = 0.5;//scale.y;
    if(textureIcon.width > textureIcon.height){
      planeHeight = 0.5 * textureIcon.height / textureIcon.width;
    }else{
      planeWidht = 0.5 * textureIcon.width / textureIcon.height;
    }
    materialIcon.diffuseMap = textureIcon;
    materialIcon.opacityMap = textureIcon;
    materialIcon.update();
    billboardIconMesh.setLocalScale(new pc.Vec3(planeWidht, 1, planeHeight));
  }

  const AddAmenityLayouts = async (layoutNode: pc.Entity, amenityID: string, materialBorder: pc.Material, materialLayout: pc.Material, bgColor: pc.Color) => {
    let childNumber = 0;
    for (const childNode of layoutNode.children) {
      let material: pc.Material | null = null;
      if(childNode.name.toLowerCase().includes("lattice")){
        childNode.name = `amenityl${childNumber}@${amenityID}`;
        material = materialBorder;
      }
      if(childNode.name.toLowerCase().includes("shape")){
        childNode.name = `amenitys${childNumber}@${amenityID}`;
        material = materialLayout;
      }
      if(material){
        PlayCanvasHelper.SetNodeMaterial(childNode, material);
      }
      childNumber = childNumber + 1;
    }
    amenitiesRef.current.highlights[amenityID] = layoutNode;
  }

  //TODO
  const AddPropertyBillboard = async (endPointNode: pc.GraphNode, propertyName: string, propertyID: string, bgColor: pc.Color, textColorString: string, textFillString: string) => {
    if(!billboardAssetsRef.current.propertyTexture || !appRef.current)
      return;

    const billboardEnd = new pc.Entity("propertyBB@"+propertyID);
    appRef.current.root.addChild(billboardEnd);
    billboardEnd.setPosition(endPointNode.getPosition().clone());
    billboardEnd.addComponent('script');

    const textMesh = CreatePropertyBillboard(billboardEnd, propertyID, propertyName, "property", new pc.Color(1,1,1), bgColor);
    billboardEnd.addChild(textMesh!);
    
    billboardEnd.enabled = false;
    propertiesRef.current.billboards[propertyID] = billboardEnd;
  }

  const AddPropertyLayouts = async (layoutNode: pc.Entity, propertyID: string, bgColor: pc.Color, materialBorder: pc.Material, materialLayout: pc.Material) => {
    
    let childNumber = 0;
    for (const childNode of layoutNode.children) {
      let material: pc.Material | null = null;
      if(childNode.name.toLowerCase().includes("lattice")){
        childNode.name = `propertyl${childNumber}@${propertyID}`;
        material = materialBorder;
      }
      if(childNode.name.toLowerCase().includes("shape")){
        childNode.name = `propertys${childNumber}@${propertyID}`;
        material = materialLayout;
      }
      if(material){
        PlayCanvasHelper.SetNodeMaterial(childNode, material);
      }
      childNumber = childNumber + 1;
    }

    const hslColor = PlayCanvasHelper.Rgb2Hsl(bgColor);
    const selectedColor = PlayCanvasHelper.Hsl2Rgb(hslColor.h, hslColor.s, 1);
    layoutNode.addComponent('script');
    layoutNode.script?.create('propertyBehavior', {
      attributes: {
        propertyID: propertyID,
      }
    });
    layoutNode.script?.["propertyBehavior"].SetRefs(isPortraitRef, selectedAptoRef);
    layoutNode.script?.["propertyBehavior"].SetAnimationColors(bgColor, selectedColor);
    layoutNode.script?.["propertyBehavior"].SetAnimationMaterials(materialBorder, materialLayout);

    propertiesRef.current.highlights[propertyID] = layoutNode;
  }

  ///TODO
  const AddTownPlanningBillboard = async (endPointNode: pc.GraphNode, townPlanningID: string, townPlanningName: string, color: pc.Color) => {
    const billboard = new pc.Entity("propertyTP@"+townPlanningID);
    billboard.addComponent('script');
    endPointNode.addChild(billboard);
    const textMesh = PlayCanvasHelper.CreateCapsuleBillboardTextNode(billboardAssetsRef.current, billboard, townPlanningID, montserratMediumFontIDRef.current, townPlanningName, new pc.Color(1,1,1), color, 100, false, false);
    billboard.script?.["billboardCapsuleScalerAndLookAt"].ChangeLookAtEntity(cameraEntityRef.current);
    billboard.addChild(textMesh);
  }

  const AddTownPlanningLayouts = async (layoutNode: pc.GraphNode, townPlanningID: string, color: pc.Color) => {
    const materialBorder = PlayCanvasHelper.CreateLayoutMaterialFromColor("borderMat@allamenities", color, true, 1.0);
    const materialLayout = PlayCanvasHelper.CreateLayoutMaterialFromColor("layoutMat@allamenities", color, true, 0.3);

    let childNumber = 0;
    for (const childNode of layoutNode.children) {
      let material: pc.Material | null = null;
      if(childNode.name.toLowerCase().includes("lattice")){
        childNode.name = `tp_l${childNumber}@${townPlanningID}`;
        material = materialBorder;
      }
      if(childNode.name.toLowerCase().includes("shape")){
        childNode.name = `tp_s${childNumber}@${townPlanningID}`;
        material = materialLayout;
      }
      if(material){
        PlayCanvasHelper.SetNodeMaterial(childNode, material);
      }
      childNumber = childNumber + 1;
    }
  }

  const CreatePropertyBillboard = (billboardEnd: pc.Entity, propertyID: string, texto: string, prefix: string, textColor: pc.Color, colorFill: pc.Color) : pc.Entity|null => {
    if(!appRef.current || !billboardAssetsRef.current)
      return null;
    
    const worldScreen = new pc.Entity("WorldScreen"+texto);
    worldScreen.addComponent("screen", {
      screenSpace: false,
      resolution: pc.Vec2.ONE,
      referenceResolution: new pc.Vec2(1280, 720),
      //scaleMode: "blend",
    });
    worldScreen.setLocalEulerAngles(0, 180, 0);
    worldScreen.setLocalScale(0.01, 0.01, 0.01);

    const background = new pc.Entity(prefix+"BG"+texto);
    background.addComponent("element", {
      type: pc.ELEMENTTYPE_IMAGE,
      texture: billboardAssetsRef.current.propertyTexture,
      pivot: new pc.Vec2(0.5, 0.5),
      anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
      color: colorFill,
      width: 1000,
      height: 1000,
      useInput: true,
    });
    background.element!.layers = [pc.LAYERID_WORLD];
    worldScreen.addChild(background);

    const text = new pc.Entity(prefix+"_"+texto);
    text.addComponent("element", {
      type: pc.ELEMENTTYPE_TEXT,
      fontAsset: montserratMediumFontIDRef.current,
      text: ` ${texto} `,
      pivot: new pc.Vec2(0.5, 0.5),
      anchor: new pc.Vec4(0, 0, 1, 1),
      margin: new pc.Vec4(0, 0, 0, 0),
      autoWidth: false,
      autoHeight: false,
      autoFitWidth: true,
      autoFitHeight: true,
      minFontSize: 100,
      maxFontSize: 1000,
      color: textColor,
    });
    text.element!.layers = [pc.LAYERID_WORLD];
    background.addChild(text);

    const hslColor = PlayCanvasHelper.Rgb2Hsl(colorFill);
    const selectedColor = PlayCanvasHelper.Hsl2Rgb(hslColor.h, hslColor.s, 1);

    billboardEnd.script?.create('propertyBehavior', {
      attributes: {
        propertyID: propertyID,
        endEntity: billboardEnd,
        scaleReduction: 500,
        lookAtEntity: cameraEntityRef.current,
        freeRotation: true,

        bgBillboardEntity: background,
        textBillboardEntity: text,
      }
    });
    billboardEnd.script?.["propertyBehavior"].SetRefs(isPortraitRef, selectedAptoRef);
    billboardEnd.script?.["propertyBehavior"].SetAnimationColors(colorFill, selectedColor);
    return worldScreen;
  }

  const CalcStats = (deltaTime: number): void => {
    if(!appRef.current || !showProfilerRef.current)
      return;
    profilerTimerRef.current = profilerTimerRef.current + deltaTime;
    if(profilerTimerRef.current > 1){
      profilerTimerRef.current = 0;
      const profiler = {
        drawCalls: appRef.current.stats.drawCalls.total,
        fps: appRef.current.stats.frame.fps,
        frameTimeInMillis: 0.01*Math.round(100*appRef.current.stats.frame.ms)
      };
      console.log(profiler);
    }
  }

  const WaitForNextFrames = async (minFrameWait: number = 1) : Promise<void>  => {
    return new Promise((resolve, reject) => {
      const currentFrame = frameCountRef.current;
      const intervalID = setInterval(() => {
        if(frameCountRef.current >  currentFrame + minFrameWait - 1){
          clearInterval(intervalID);
          resolve();
        }
      }, 10);
    })
  }

  const SceneFrame = (deltaTime: number): void => {
    frameCountRef.current = frameCountRef.current + 1;
    if(!appRef.current || !cameraEntityRef.current || !materialGaussian.current)
      return;

    CalcStats(deltaTime);
    if(introAnimation){
      timerRef.current = timerRef.current + (startTimer.current === true ? deltaTime : 0);
      materialGaussian.current.setParameter('time', Math.max(1.0, timerRef.current * 4 + 1.0));
      materialGaussian.current.setParameter('mode', 0);      
    }

    if(showCameraPosition){ console.log("camera:", cameraEntityRef.current.getPosition()); }

    // if(colorAnimationRef.current){
    //   const colorAnimation = colorAnimationRef.current;
    //   colorAnimation.currentTimer += deltaTime * colorAnimation.direction;
    //   if(colorAnimation.currentTimer > 0.5){
    //     colorAnimation.currentTimer = 0.5;
    //     colorAnimation.direction = -1;
    //   }else if(colorAnimation.currentTimer < 0){
    //     colorAnimation.currentTimer = 0;
    //     colorAnimation.direction = 1;
    //   }
    //   const lerpedColor = new pc.Color();
    //   lerpedColor.lerp(colorAnimation.color, new pc.Color(1, 1, 1), 2*colorAnimation.currentTimer);
    //   for (const material of colorAnimation.materials){
    //     material.emissive = lerpedColor.clone();
    //     material.specular = lerpedColor.clone();
    //     material.update();
    //   }
    // }
  }

  return (
  <div className={`gsplat-container ${(sceneReady === true && isSideBarAsoleacion === false && menuSelected !== "Ubicación") ? 'visible' : ''}`}>
    <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }}/>
  </div>
  )
}

export default GaussianEngine;
